import { render, staticRenderFns } from "./AllImgFile.vue?vue&type=template&id=651b1b58&scoped=true&"
import script from "./AllImgFile.vue?vue&type=script&lang=js&"
export * from "./AllImgFile.vue?vue&type=script&lang=js&"
import style0 from "./AllImgFile.vue?vue&type=style&index=0&id=651b1b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b1b58",
  null
  
)

export default component.exports